import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';

const Children: React.FC<{}> = ({ children, ...props }) => <>{children}</>;

const RequireAuth = withAuthenticationRequired(Children, {});

export { RequireAuth };
